//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 18.04.2016.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .factory('entityService', entityService);

    function entityService() {

        var service = {};

        service.addToDashboard = function (id) {

            console.log('addToDashboard', id);
        };

        service.share = function (id) {

            console.log('share', id);
        };

        return service;
    }
})();